"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_toastify_1 = require("react-toastify");
const _state_1 = require("../ThemeProvider/_state");
class Toast {
    static success(content, options) {
        const theme = (0, _state_1.getCurrentTheme)();
        react_toastify_1.toast.success(content, Object.assign(Object.assign({}, options), { style: Object.assign({}, (theme ? { background: theme.feedbackColor.positive.pure } : {})) }));
    }
    static error(content, options) {
        const theme = (0, _state_1.getCurrentTheme)();
        react_toastify_1.toast.error(content, Object.assign(Object.assign({}, options), { style: Object.assign({}, (theme ? { background: theme.feedbackColor.negative.pure } : {})) }));
    }
    static info(content, options) {
        const theme = (0, _state_1.getCurrentTheme)();
        react_toastify_1.toast.info(content, Object.assign(Object.assign({}, options), { style: Object.assign({}, (theme ? { background: theme.feedbackColor.informative.pure } : {})) }));
    }
}
exports.default = Toast;
